import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login'

import Home from '@/components/Home'

import CentroAdmin from '@/components/Centro-admin'
import PazienteReport from '@/components/Paziente-report'

import CentroProfile from '@/components/Centro-profile'
import CentroDocumenti from '@/components/Centro-documenti'
import CentroInapprovazione from '@/components/Centro-inapprovazione'
import CentroMateriale from '@/components/Centro-materiale'
import CentroVon from '@/components/Centro-von'

import Contatto from '@/components/Contatto'
import ContattoEdit from '@/components/Contatto-edit'

import SchedaDatigenerali from '@/components/Scheda-datigenerali'
import SchedaPerinatale from '@/components/Scheda-perinatale'
import SchedaSalaparto from '@/components/Scheda-salaparto'
import SchedaDecorso from '@/components/Scheda-decorso'
import SchedaDimissione from '@/components/Scheda-dimissione'
import SchedaTrasferimento from '@/components/Scheda-trasferimento'


import VonFiles from '@/components/Von-files'
import VonImport from '@/components/Von-import'

import Loadpage from '@/components/Loadpage'
import PageEdit from '@/components/Page-edit'


import ReportBasico from '@/components/Report-basico'
import ReportConfidenza from '@/components/Report-confidenza'


import CaterpillarFdisp from '@/components/Caterpillar-fdisp'
import CaterpillarSteroidi from '@/components/Caterpillar-steroidi'
import CaterpillarTemperatura from '@/components/Caterpillar-temperatura'
import CaterpillarEyex from '@/components/Caterpillar-eyex'
import CaterpillarLbpath from '@/components/Caterpillar-lbpath'
import CaterpillarLbpath2 from '@/components/Caterpillar-lbpath2'
import CaterpillarBpd from '@/components/Caterpillar-bpd'
import CaterpillarNec from '@/components/Caterpillar-nec'
import CaterpillarEntfeed from '@/components/Caterpillar-entfeed'
import CaterpillarEntfeed2 from '@/components/Caterpillar-entfeed2'
import CaterpillarVagdel from '@/components/Caterpillar-vagdel'


import CaterpillarShrunkenFdisp from '@/components/Caterpillar-shrunken-fdisp'


import FunnelFdisp from '@/components/Funnel-fdisp'
import FunnelSteroidi from '@/components/Funnel-steroidi'
import FunnelTemperatura from '@/components/Funnel-temperatura'

import Funnel2022 from '@/components/Funnel-2022'
import FunnelFdispGrezza2022 from '@/components/Funnel-fdisp-grezza-2022'
import FunnelFdispGrezzaPlus2022 from '@/components/Funnel-fdisp-grezza-plus10-2022'
import FunnelFdispAggiustata2022 from '@/components/Funnel-fdisp-aggiustata-2022'
import FunnelFdispAggiustataPlus2022 from '@/components/Funnel-fdisp-aggiustata-plus10-2022'


import Funnel2021 from '@/components/Funnel-2021'
import FunnelFdisp2021 from '@/components/Funnel-fdisp-2021'
import FunnelSteroidi2021 from '@/components/Funnel-steroidi-2021'
import FunnelTemperatura2021 from '@/components/Funnel-temperatura-2021'
import FunnelEyex2021 from '@/components/Funnel-eyex-2021'
import FunnelLbpath2021 from '@/components/Funnel-lbpath-2021'
import FunnelBpd2021 from '@/components/Funnel-bpd-2021'
import FunnelNec2021 from '@/components/Funnel-nec-2021'
import FunnelEntfeed2021 from '@/components/Funnel-entfeed-2021'
import FunnelEntfeed22021 from '@/components/Funnel-entfeed2-2021'
import FunnelVagdel2021 from '@/components/Funnel-vagdel-2021'

Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/network/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/',  redirect: '/home'},
    { path: '/login/:tipo?', name: 'login', meta: {}, components:{main: Login  },props: {main: true}  }, 
    { path: '/autologin/:email/:id', name: 'autologin', meta: {}, components:{main: Login  },props: {main: true}  }, 
    { path: '/registrazione', name: 'registrazione', meta: { newuser: true}, components:{main: Login  } }, 

    { path: '/home', name: 'home', meta: { requiresAuth: true }, components:{main: Home  } }, 

    { path: '/centro-admin', name: 'centro.admin', meta: { requiresAuth: false }, components: { main: CentroAdmin } }, 
    { path: '/paziente-report', name: 'paziente.report', meta: { requiresAuth: false }, components: { main: PazienteReport } }, 

    { path: '/centro-profile', name: 'centro.profile', meta: { requiresAuth: false }, components: { main: CentroProfile } }, 
    { path: '/centro-documenti', name: 'centro.documenti', meta: { requiresAuth: false }, components: { main: CentroDocumenti } }, 
    { path: '/centro-inapprovazione', name: 'centro.inapprovazione', meta: { requiresAuth: false }, components: { main: CentroInapprovazione } }, 
    { path: '/centro-materiale', name: 'centro.materiale', meta: { requiresAuth: false }, components: { main: CentroMateriale } }, 
    { path: '/centro-von/:id?', name: 'centro.von', meta: { requiresAuth: true }, components: { main: CentroVon } }, 

    { path: '/contatto', name: 'contatto', meta: { requiresAuth: true, requiresRef: true }, components: { main: Contatto } }, 
    { path: '/contatto-edit/:id?', name: 'contatto.edit', meta: { requiresAuth: true }, components: { main: ContattoEdit } },

    { path: '/scheda-datigenerali/:id?', name: 'scheda.datigenerali', meta: { requiresAuth: true }, components: { main: SchedaDatigenerali } }, 
    { path: '/scheda-perinatale/:id?', name: 'scheda.perinatale', meta: { requiresAuth: true }, components: { main: SchedaPerinatale } }, 
    { path: '/scheda-salaparto/:id?', name: 'scheda.salaparto', meta: { requiresAuth: true }, components: { main: SchedaSalaparto } }, 
    { path: '/scheda-decorso/:id?', name: 'scheda.decorso', meta: { requiresAuth: true }, components: { main: SchedaDecorso } }, 
    { path: '/scheda-dimissione/:id?', name: 'scheda.dimissione', meta: { requiresAuth: true }, components: { main: SchedaDimissione } }, 
    { path: '/scheda-trasferimento/:id?', name: 'scheda.trasferimento', meta: { requiresAuth: true }, components: { main: SchedaTrasferimento } }, 


    { path: '/report-basico', name: 'report.basico', meta: { requiresAuth: true }, components:{main: ReportBasico  } }, 
    
    { path: '/report-confidenza', name: 'report.confidenza', meta: { requiresAuth: true }, components:{main: ReportConfidenza  } }, 
    { path: '/caterpillar-fdisp', name: 'caterpillar.fdisp', meta: { requiresAuth: true }, components:{main: CaterpillarFdisp  } }, 
    { path: '/caterpillar-steroidi', name: 'caterpillar.steroidi', meta: { requiresAuth: true }, components:{main: CaterpillarSteroidi  } }, 
    { path: '/caterpillar-temperatura', name: 'caterpillar.temperatura', meta: { requiresAuth: true }, components:{main: CaterpillarTemperatura  } }, 
    { path: '/caterpillar-eyex', name: 'caterpillar.eyex', meta: { requiresAuth: true }, components:{main: CaterpillarEyex  } }, 
    { path: '/caterpillar-lbpath', name: 'caterpillar.lbpath', meta: { requiresAuth: true }, components:{main: CaterpillarLbpath } }, 
    { path: '/caterpillar-lbpath2', name: 'caterpillar.lbpath2', meta: { requiresAuth: true }, components:{main: CaterpillarLbpath2 } }, 
    { path: '/caterpillar-bpd', name: 'caterpillar.bpd', meta: { requiresAuth: true }, components:{main: CaterpillarBpd } }, 
    { path: '/caterpillar-nec', name: 'caterpillar.nec', meta: { requiresAuth: true }, components:{main: CaterpillarNec } }, 
    { path: '/caterpillar-entfeed', name: 'caterpillar.entfeed', meta: { requiresAuth: true }, components:{main: CaterpillarEntfeed } }, 
    { path: '/caterpillar-entfeed2', name: 'caterpillar.entfeed2', meta: { requiresAuth: true }, components:{main: CaterpillarEntfeed2 } }, 
    { path: '/caterpillar-vagdel', name: 'caterpillar.vagdel', meta: { requiresAuth: true }, components:{main: CaterpillarVagdel } }, 

    { path: '/caterpillar-shrunken-fdisp', name: 'caterpillar.shrunken.fdisp', meta: { requiresAuth: true }, components:{main: CaterpillarShrunkenFdisp  } }, 



    { path: '/funnel-2022', name: 'funnel.2022', meta: { requiresAuth: true }, components:{main: Funnel2022  } },     
    { path: '/funnel-fdisp-grezza-2022', name: 'funnel.fdisp.grezza.2022', meta: { requiresAuth: true }, components:{main: FunnelFdispGrezza2022  } }, 
    { path: '/funnel-fdisp-grezza-plus10-2022', name: 'funnel.fdisp.grezza.plus10.2022', meta: { requiresAuth: true }, components:{main: FunnelFdispGrezzaPlus2022  } }, 
    { path: '/funnel-fdisp-aggiustata-2022', name: 'funnel.fdisp.aggiustata.2022', meta: { requiresAuth: true }, components:{main: FunnelFdispAggiustata2022  } }, 
    { path: '/funnel-fdisp-aggiustata-plus10-2022', name: 'funnel.fdisp.aggiustata.plus10.2022', meta: { requiresAuth: true }, components:{main: FunnelFdispAggiustataPlus2022  } }, 

    { path: '/funnel-2021', name: 'funnel.2021', meta: { requiresAuth: true }, components:{main: Funnel2021  } }, 
    { path: '/funnel-fdisp-2021', name: 'funnel.fdisp.2021', meta: { requiresAuth: true }, components:{main: FunnelFdisp2021  } }, 
    { path: '/funnel-steroidi-2021', name: 'funnel.steroidi.2021', meta: { requiresAuth: true }, components:{main: FunnelSteroidi2021  } }, 
    { path: '/funnel-temperatura-2021', name: 'funnel.temperatura.2021', meta: { requiresAuth: true }, components:{main: FunnelTemperatura2021  } }, 
    { path: '/funnel-eyex-2021', name: 'funnel.eyex.2021', meta: { requiresAuth: true }, components:{main: FunnelEyex2021  } }, 
    { path: '/funnel-lbpath-2021', name: 'funnel.lbpath.2021', meta: { requiresAuth: true }, components:{main: FunnelLbpath2021  } }, 
    { path: '/funnel-bpd-2021', name: 'funnel.bpd.2021', meta: { requiresAuth: true }, components:{main: FunnelBpd2021  } }, 
    { path: '/funnel-nec-2021', name: 'funnel.nec.2021', meta: { requiresAuth: true }, components:{main: FunnelNec2021  } }, 
    { path: '/funnel-entfeed-2021', name: 'funnel.entfeed.2021', meta: { requiresAuth: true }, components:{main: FunnelEntfeed2021  } }, 
    { path: '/funnel-entfeed2-2021', name: 'funnel.entfeed2.2021', meta: { requiresAuth: true }, components:{main: FunnelEntfeed22021  } }, 
    { path: '/funnel-vagdel-2021', name: 'funnel.vagdel.2021', meta: { requiresAuth: true }, components:{main: FunnelVagdel2021  } }, 

    { path: '/funnel-fdisp', name: 'funnel.fdisp', meta: { requiresAuth: true }, components:{main: FunnelFdisp  } }, 
    { path: '/funnel-steroidi', name: 'funnel.steroidi', meta: { requiresAuth: true }, components:{main: FunnelSteroidi  } }, 
    { path: '/funnel-temperatura', name: 'funnel.temperatura', meta: { requiresAuth: true }, components:{main: FunnelTemperatura  } }, 

    { path: '/von-files', name: 'von.files', meta: { requiresAuth: true }, components: { main: VonFiles } }, 

    { path: '/loadpage/:area/:filename', name: 'inside',  meta: { inside:'inside', nav: true }, components:{main: Loadpage },props: {main: true} }, 
    { path: '/page-edit', name: 'pageEdit', meta: { requiresAuth: false }, components: { main: PageEdit } },

    { path: '/von-import/', name: 'von.import', meta: { requiresAuth: true }, components:{main: VonImport} },

    { path: '*', redirect: '/home' } 
  ]


})



router.beforeEach((to, from, next) => {
  console.log("\nbeforeEach \nfrom: "+from.path+"\nto: "+to.path+"\n\n")
  teras.router.from = from.path
  teras.router.to = to.path

  console.log(to.query)
  console.log(to)

  if(to.name=='autologin'){
    console.log("EFFETTUO LE OPERAZIONI DI AUTOLOGIN "+ teras.name)
    teras.event.emit('autologin', to)
  }
  
  
  if(!teras.app.ready){
     if(teras.ttl()){
        console.log("TTLCLEAR lancio appClear")
        teras.event.emit('appClear')
     }
     console.log("EFFETTUO LE OPERAZIONI AL PRIMO AVVIO DELLA APP "+ teras.name)
     teras.event.emit('routerFirst', to)
     return true
  }

  if (to.matched.some(record => record.meta.requiresAuth)){
     console.log("SONO RICHIESTI I PERMESSI..... LI CONTROLLO")
     if(teras.app.auth){
        console.log("....PERMESSI VERIFICATI, PROCEDO!")
        next()
     }else{
        console.log("....PERMESSI MANCANTI, LO MANDO A: "+teras.app.routeInitial)
        teras.event.emit('routerNoauth',to)
        next(teras.app.routeNoauth)
     }
  }else{
     console.log("NON SONO RICHIESTI PERMESSI")
     next()
  }
  teras.app.drawer = false
  teras.event.emit('routerChange', to)
})

export default router
